/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compliance_Template_Button_CopyInputs */



/**
* | output |
* | --- |
* | "Copy Template" |
*
* @param {Compliance_Template_Button_CopyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const compliance_template_button_copy = /** @type {((inputs?: Compliance_Template_Button_CopyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compliance_Template_Button_CopyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Vorlage kopieren")
	return /** @type {LocalizedString} */ ("Copy Template")
});